<template lang="pug">
  v-dialog(
    v-model="show"
    max-width="500px"
  )
    v-card
      v-card-title.d-flex.flex-column
        span.headline {{ ownReview ? 'Update Review' : 'Add Review' }}
        small
          em {{ merchantName }} 
          em(v-if="storeName") - {{ storeName }}  
      v-card-text
        v-form(
          class=""
          ref="review"
          v-model="valid"
          lazy-validation
        )
          v-row(
            class="mb-2"
          )
            span(class="grey--text text--lighten-2 text-caption my-auto mx-3") ({{ star }})
            v-rating(
              v-model="star"
              color="accent"
              dense
              half-increments
              hover
              size="24"
            )
          v-textarea(
            class="mt-4"
            :counter="300"
            :rules="rules"
            v-model="comment"
            label="Review Comment"
            required
          )
      v-card-actions
        v-spacer
        v-btn(
          color="blue darken-1"
          text
          @click="close"
        ) Cancel
        v-btn(
          color="blue darken-1"
          text
          @click="review"
        ) Submit
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  props: {
    dialog: Boolean,
    merchantId: String,
    storeId: String,
    merchantName: String,
    storeName: String,
    ownReview: Object
  },
  data() {
    return {
      rules: [
        v => !!v || "Comment is required",
        v => (v && v.length < 301) || "Comment must be less than 300 characters"
      ],
      valid: false,
      comment: "",
      star: 0,
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    show: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("close");
      }
    }
  },
  mounted() {
    if (this.ownReview) {
      this.star = parseFloat(this.ownReview.review_star);
      this.comment = this.ownReview.review_comment;
    } else {
      this.star = 0;
      this.comment = "";
    }
  },
  methods: {
    review() {
      if (!this.$refs.review.validate()) return;

      let url = config.reviewUrl();

      var json = {
        merchant_id: this.merchantId,
        store_id: this.storeId,
        review_star: this.star,
        review_comment: this.comment,
        customer_id: this.$store.getters.customerId,
        customer_sessiontoken: this.$store.getters.sessionToken
      };

      console.log(json);

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.done();
              } else {
                this.$swal(
                  this.$t("error.leave_review"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.leave_review"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.leave_review"),
            response.body.message,
            "error"
          );
        });
    },
    close() {
      this.$emit("close");
    },
    done() {
      this.$emit("done");
      this.$emit("close");
    }
  }
};
</script>
